import { Injectable } from '@angular/core';
import { NgBlockUI }  from 'ng-block-ui';
import { NgbModal }   from '@ng-bootstrap/ng-bootstrap';

import { ApiService }                          from '../api/api.service';
import { BigDecimalService }                   from '../core/services/big-decimal.service';
import { ChargifyActivateComponent }           from './chargify.activate.component';
import { ChargifyExportCancelationsComponent } from './chargify.export-cancelations.component';
import { ChargifyQuoteModel }                  from './models/chargify.quote';
import { CodeTypeModel }                       from '../core/models/code-type';
import { CompanySubscriptionModel }            from '../companies/models/company.subscription';
import { SessionService }                      from '../sessions/session.service';

@Injectable({
  providedIn: 'root'
})
export class ChargifyService {
  constructor (
    private apiService       : ApiService,
    private bigDecimalService: BigDecimalService,
    private modalService     : NgbModal,
    private sessionService   : SessionService
  ) {}

  activate ( block ?: NgBlockUI ) : Promise<any> {
    if (block) {
      block.start();
    }

    return this.getQuote()
    .finally(() => {
      if (block) {
        block.stop();
      }
    })
    .then((quotes : ChargifyQuoteModel) => {
      const modalRef = this.modalService.open(ChargifyActivateComponent, {
        size: 'lg'
      });

      modalRef.componentInstance.quotes = quotes;

      return modalRef.result;
    });
  }

  exportCancelations () : Promise<any> {
    const modelRef = this.modalService.open(ChargifyExportCancelationsComponent);

    return modelRef.result;
  }

  getCountryTypes () : Promise<Array<CodeTypeModel>> {
    return this.apiService.get('/system/country_types', null, 'countries', {
        bypass: true
      });
  }

  getQuote () : Promise<ChargifyQuoteModel> {
    return this.apiService.get('/chargify/quote_all_for_activation');
  }

  getRate ( value : string ) : string {
    const company = this.sessionService.company();

    const symbol = (
      company.subscription_subdomain === 'workshop-software-uk' ||
      company.subscription_subdomain === 'ari-uk' ||
      company.subscription_subdomain === 'workshop-software-eu'
    ) ? '£' : '$';

    try {
      const rate   = this.bigDecimalService.get(value);
      const twelve = this.bigDecimalService.get('12');

      return ` (${ symbol }${ rate.divide(twelve).toString() } x 12)`;
    }
    catch (error) {
      return '';
    }
  }

  getStates ( country : string ) : Promise<Array<CodeTypeModel>> {
    return this.apiService.get('/system/states_for_country', country, null, {
      bypass: true
    });
  }

  getSubscription ( company = this.sessionService.company() ) : Promise<CompanySubscriptionModel> {
    return this.apiService.get('company/get_chargify_subscription', company.id);
  }

  status ( status : string ) : boolean {
    const company = this.sessionService.company();

    return company?.subscription_status
      && company.subscription_status.toLowerCase() === status.toLowerCase();
  }

  updatePayment ( subscription : any ) : Promise<any> {
    return this.apiService.post('/chargify/update_payment', subscription, 'subscription')
      .then(() => this.sessionService.refresh());
  }
}
